import Synth from './Synth';
export default Synth;